module.exports = __webpack_public_path__ + "static/images/column-btn.9745db3.png";